// import axios from "axios";
import apiFarms from "../config/api_farms";
import getHeaders from "./getHeaders";

// const apiFarms = axios.create({
//   baseURL: "http://localhost:8082",
// });

export function findAllReproductionParemeterFarmByGroupIdAndFarmId(payload) {
  const { groupId, farmId } = payload;

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/reproduction/parameters`,
    getHeaders(false, null)
  );
}

export function saveReproductionParemeterFarm(payload) {
  const { groupId, farmId, body } = payload;

  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/reproduction/parameters`,
    body,
    getHeaders(false, null)
  );
}
